

export const BACKEND_URL: string = process.env.REACT_APP_BACKEND_URL || "https://kundenportal.abk.at:9000";
// export const BACKEND_URL: string = "http://localhost:8080";

export const LOCAL_JWT = localStorage.getItem("jwt");
export const JWT_HEADER = {Authorization: `Bearer ${LOCAL_JWT}`};
